import {
  Box,
  Button,
  Grid,
  Step,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { OrganizationUserContext } from "contexts/Organization";
import { SlideAnimationContext } from "contexts/SlideAnimation";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { CURRENT_VA_STEP } from "utils/localStorage";
import { getSource, trackEvent } from "utils/tracking";
import { useTracking } from "utils/useTracking";

import { vaSelfServeNavigate } from "../helpers";
import styles from "./styles";

const Welcome = () => {
  const { currentOrg } = useContext(OrganizationUserContext);
  const [activeStep, setActiveStep] = useState(0);
  const { trackVaStep } = useTracking();
  const { subscription } = useContext(SubscriptionContext);

  const source = getSource();

  const navigate = useNavigate();
  const location = useLocation();
  const slideContext = useContext(SlideAnimationContext);
  const handleNext = async () => {
    if (activeStep === 0) {
      setActiveStep(1);
      return;
    }
    trackVaStep(location.pathname, source, true);
    if (slideContext) {
      await slideContext.slideOutUp();
      slideContext.slideInUp();
    }
    navigate(
      `/${vaSelfServeNavigate(location.pathname, "next")}${location.search}`,
    );
  };

  const currentStep = localStorage.getItem(
    `${CURRENT_VA_STEP}-${currentOrg?.id}`,
  );

  const steps = [
    {
      label: "🪄 We Pitch",
      description: `Bento sends 300 brand pitches for you every month using your
          chosen template - targeting the exact contact emails we've seen leading to paid deals in the past.`,
    },
    {
      label: "📥 You Respond",
      description:
        "You are responsible for responding to and negotiating with brands when you get a response.",
    },
  ];

  useEffect(() => {
    trackEvent(
      "VA Onboarding Flow - Bento's Income Guaranteed Program Steps Viewed",
      {
        Step: steps[activeStep]?.label,
      },
    );
    if (currentOrg?.id && activeStep > 0) {
      localStorage.setItem(
        `${CURRENT_VA_STEP}-${currentOrg?.id}`,
        activeStep?.toString(),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep]);

  useEffect(() => {
    if (currentStep && parseInt(currentStep) !== activeStep) {
      setActiveStep(parseInt(currentStep));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Typography variant="h3" gutterBottom sx={{ textAlign: "center", mt: 0 }}>
        Welcome to Bento's Virtual Assistant 🎉
      </Typography>
      {subscription?.ouiStudioData && (
        <Typography gutterBottom textAlign={"center"}>
          You'll get an email separately about your Out-of-Office Club
          subscription shortly!
        </Typography>
      )}
      <Box sx={{ maxWidth: 1000 }}>
        <Stepper activeStep={activeStep} orientation="vertical">
          {steps.map((step, index) => (
            <Step key={step.label} expanded={activeStep >= index}>
              <StepLabel>{step.label}</StepLabel>
              <StepContent>
                <Typography sx={styles.description}>
                  {step.description}
                </Typography>
                <Box sx={{ mb: 2 }}>
                  {activeStep === index && index !== steps?.length - 1 && (
                    <Button
                      onClick={handleNext}
                      sx={{ mt: 1, mr: 1, textTransform: "none" }}
                      size="small"
                      disableElevation
                      variant="contained"
                    >
                      Continue
                    </Button>
                  )}
                </Box>
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Box>

      <Grid item xs="auto" container columnGap={1} sx={{ mt: 4 }}>
        <Grid item xs></Grid>
        <Grid item xs="auto">
          <Button disableElevation onClick={handleNext}>
            Next
            <Box
              sx={{ ml: 1 }}
              component="i"
              className="fa-solid fa-arrow-right"
            />
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default Welcome;
